import { render } from "./hotelsBookOffline.vue?vue&type=template&id=884dd55c&scoped=true"
import script from "./hotelsBookOffline.vue?vue&type=script&lang=js"
export * from "./hotelsBookOffline.vue?vue&type=script&lang=js"

import "./hotelsBookOffline.vue?vue&type=style&index=0&id=884dd55c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884dd55c"]])

export default __exports__